import { useMemo } from 'react'

import {
  QueryConfigProvider,
  CountryConfigProvider,
} from '@ngb-frontend/shared/context'
import { resolveBrandRules } from '@ngb-frontend/shared/rules'
import { FullScreenLoader } from '@ngb-frontend/shared/ui'

import { useBusinessRules, countrySettingToConfig } from './utils'

import type { QueryParams } from '@ngb-frontend/shared/types'

export const ConfigProviders = ({
  children,
  initialQuery,
  onQueryChange,
  isAyvens,
}: {
  children: React.ReactNode
  initialQuery: QueryParams | null
  onQueryChange: (initialQuery: QueryParams | null) => void
  isAyvens: boolean
}) => {
  const { data: countrySettingsData, isLoading: countrySettingsLoading } =
    useBusinessRules(initialQuery?.country, isAyvens)

  const countryConfig = useMemo(() => {
    if (!countrySettingsData) return

    const fetchedConfig = countrySettingToConfig(countrySettingsData[0])
    // Autopick is now a country brand rule (NGRE2E-4011); it used to come from
    // the AUTOPICK_PNR_SUPPLIER_COUNTRIES deploy env
    const staticConfig = {
      autopickPNRSupplier: resolveBrandRules(initialQuery?.country)
        .autopickSupplier,
    }

    return { ...fetchedConfig, ...staticConfig }
  }, [countrySettingsData, initialQuery?.country])

  if (countrySettingsLoading) return <FullScreenLoader />

  return (
    <QueryConfigProvider
      initialQuery={initialQuery}
      onQueryChange={onQueryChange}
    >
      <CountryConfigProvider
        isAyvens={isAyvens}
        country={initialQuery?.country}
        countryConfig={countryConfig}
      >
        {children}
      </CountryConfigProvider>
    </QueryConfigProvider>
  )
}
